import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';

export type Companies = CommonColumns & {
  resourceName: string;
  name: string;
  corporateNumber: string;
  homepageUrl: string;
  headOfficeAddress: string;
  organizationsCount: string;
};

// FIXME: refine
export const companies: Readonly<Companies> = {
  ...commonColumns,
  ...{
    resourceName: '企業',
    name: '企業名',
    corporateNumber: '法人番号',
    homepageUrl: '会社概要URL',
    headOfficeAddress: '本社所在地',
    organizationsCount: '組織数',
  },
};
